module.exports = __webpack_public_path__ + "img/T5-A-xs_05.919b87cb.png";